<template>
  <div id="setting-page-permission">
    <div>
      <span class="fs-dbb-20">{{ $t("engine.managePage.pageAddEdit.permission.lblPermission", languageEngine) }}</span>
      <span class="fs-db-20 text-muted ml-5">({{ languageUse && languageUse.toUpperCase() }})</span>
    </div>

    <div>
      <b-row class="mt-15">
        <b-col
          cols="4"
          v-for="(value, index) in _types"
          :key="`permission_page_${value}_${index}`"
          class="type-permission"
          :class="{ active: value === permissionType }"
          @click="onChangeType(value)"
          style="cursor: pointer"
          @mouseover="isHover = value"
          @mouseleave="isHover = ''"
        >
          <component
            :is="`${languageEngine}_permission_page_${value}`"
            v-if="isHover !== value && value !== permissionType"
            class="permission_page"
          />
          <component
            :is="`${languageEngine}_permission_page_${value}_hover`"
            v-if="isHover === value && value !== permissionType"
            class="permission_page_hover"
          />
          <component
            :is="`${languageEngine}_permission_page_${value}_active`"
            v-if="value === permissionType"
            class="permission_page_active"
          />
        </b-col>
      </b-row>
      <b-row class="mt-15 align-items-center">
        <b-col cols="12" v-if="permissionType === 'public'">
          {{ $t("engine.managePage.pageAddEdit.permission.lblPublicDescription", languageEngine) }}
        </b-col>
        <b-col cols="12" v-if="permissionType === 'password'">
          {{ $t("engine.managePage.pageAddEdit.permission.lblPasswordDescription", languageEngine) }}
        </b-col>
        <b-col cols="12" v-if="permissionType === 'member'">
          {{ $t("engine.managePage.pageAddEdit.permission.lblMemberDescription", languageEngine) }}
        </b-col>
      </b-row>
    </div>

    <PermissionPassword 
      v-if="permissionType === 'password'" 
      :data="data"
      :validate="validate"
      @clear="permissionType = 'public'"
    />
    <PermissionMember 
      v-if="permissionType === 'member'" 
      :data="data"
      :validate="validate"
      @clear="permissionType = 'public'"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import PermissionPassword from "./PermissionPassword.vue";
import PermissionMember from "./PermissionMember.vue";
import pageService from "@services/pageService.js";

const Component = {
  en_permission_page_public: () => import(/* webpackChunkName: "en_permission_page_public" */ "./Input/images/en/Public.vue"),
  en_permission_page_public_active: () => import(/* webpackChunkName: "en_permission_page_public_active" */ "./Input/imagesActive/en/Public.vue"),
  en_permission_page_public_hover: () => import(/* webpackChunkName: "en_permission_page_public_hover" */ "./Input/imagesHover/en/Public.vue"),

  en_permission_page_member: () => import(/* webpackChunkName: "en_permission_page_member" */ "./Input/images/en/Member.vue"),
  en_permission_page_member_active: () => import(/* webpackChunkName: "en_permission_page_member_active" */ "./Input/imagesActive/en/Member.vue"),
  en_permission_page_member_hover: () => import(/* webpackChunkName: "en_permission_page_member_hover" */ "./Input/imagesHover/en/Member.vue"),
  
  en_permission_page_password: () => import(/* webpackChunkName: "en_permission_page_password" */ "./Input/images/en/Password.vue"),
  en_permission_page_password_active: () => import(/* webpackChunkName: "en_permission_page_password_active" */ "./Input/imagesActive/en/Password.vue"),
  en_permission_page_password_hover: () => import(/* webpackChunkName: "en_permission_page_password_hover" */ "./Input/imagesHover/en/Password.vue"),

  id_permission_page_public: () => import(/* webpackChunkName: "id_permission_page_public" */ "./Input/images/id/Public.vue"),
  id_permission_page_public_active: () => import(/* webpackChunkName: "id_permission_page_public_active" */ "./Input/imagesActive/id/Public.vue"),
  id_permission_page_public_hover: () => import(/* webpackChunkName: "id_permission_page_public_hover" */ "./Input/imagesHover/id/Public.vue"),

  id_permission_page_member: () => import(/* webpackChunkName: "id_permission_page_member" */ "./Input/images/id/Member.vue"),
  id_permission_page_member_active: () => import(/* webpackChunkName: "id_permission_page_member_active" */ "./Input/imagesActive/id/Member.vue"),
  id_permission_page_member_hover: () => import(/* webpackChunkName: "id_permission_page_member_hover" */ "./Input/imagesHover/id/Member.vue"),
  
  id_permission_page_password: () => import(/* webpackChunkName: "id_permission_page_password" */ "./Input/images/id/Password.vue"),
  id_permission_page_password_active: () => import(/* webpackChunkName: "id_permission_page_password_active" */ "./Input/imagesActive/id/Password.vue"),
  id_permission_page_password_hover: () => import(/* webpackChunkName: "id_permission_page_password_hover" */ "./Input/imagesHover/id/Password.vue"),

  th_permission_page_public: () => import(/* webpackChunkName: "th_permission_page_public" */ "./Input/images/th/Public.vue"),
  th_permission_page_public_active: () => import(/* webpackChunkName: "th_permission_page_public_active" */ "./Input/imagesActive/th/Public.vue"),
  th_permission_page_public_hover: () => import(/* webpackChunkName: "th_permission_page_public_hover" */ "./Input/imagesHover/th/Public.vue"),

  th_permission_page_member: () => import(/* webpackChunkName: "th_permission_page_member" */ "./Input/images/th/Member.vue"),
  th_permission_page_member_active: () => import(/* webpackChunkName: "th_permission_page_member_active" */ "./Input/imagesActive/th/Member.vue"),
  th_permission_page_member_hover: () => import(/* webpackChunkName: "th_permission_page_member_hover" */ "./Input/imagesHover/th/Member.vue"),
  
  th_permission_page_password: () => import(/* webpackChunkName: "th_permission_page_password" */ "./Input/images/th/Password.vue"),
  th_permission_page_password_active: () => import(/* webpackChunkName: "th_permission_page_password_active" */ "./Input/imagesActive/th/Password.vue"),
  th_permission_page_password_hover: () => import(/* webpackChunkName: "th_permission_page_password_hover" */ "./Input/imagesHover/th/Password.vue"),
};
export default {
  components: {
    PermissionPassword,
    PermissionMember,
    ...Component,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    validate: {},
  },
  data() {
    return {
      groupType: [],
      showPassword: false,
      isHover: "",
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
    _types() {
      return ["public", "password", "member"];
    },
    permissionType: {
      get() {
        return this.data.properties.permission.type;
      },
      set(val) {
        this.data.properties.permission.type = val;
      }
    },
  },
  methods: {
    capitalize,
    getMemberGroup() {
      const language = this.languageUse;
      pageService.memberGroup({ language }).then((response) => {
        this.groupType = response.data;
      });
    },
    onChangeType(value) {
      this.permissionType = value;
    }
  },
  mounted() {
    this.getMemberGroup();
  },
};
</script>

<style lang="scss">
.type-permission.active {
  color: #212529 !important;
  /* background-color: #fff !important; */

  svg {
    border-radius: 8px;
  }
}
#setting-page-permission {
  .custom-control.custom-checkbox label {
    line-height: 20px;
  }
  input[type="password"]::-ms-reveal,
  input[type="password"]::-ms-clear {
    display: none;
  }
}
</style>
